import React, { useRef, useState, useEffect, useLayoutEffect, useCallback, WheelEvent, MouseEvent } from "react";
import "../../App.css";
import {
  addItemToSelection,
  exitSelection,
  //removeItemFromSelection,
} from "../../store/model";
import {
  // setViewportBounds,
  // setMousePositionSnap,
  //setViewportSize,
  setMouseUnmodifiedPosition,
  // setWorldTransformationMatrix,
  // setZoom,
  // setPos,
} from "../../store/interface";
import "./shapes/line/lineModul"; // for sideeffect
import "./shapes/polygon/polygonModul"; // for sideeffect
import "./shapes/symbol/symbolModul"; // for sideeffect
import "./shapes/circle/circleModul"; // for sideeffect
import "./shapes/symbol/symbolModul"; // for sideeffect
import "./shapes/text/textModul"; // for sideeffect
import "./tools/rotationSymbol"; // for sideeffect
import "./tools/RectSelectSymbol"; // for sideeffect
import "./tools/moveSymbol"; // for sideeffect
import "./tools/splitSymbol"; // for sideeffect
import "./tools/mirrorSymbol"; // for sideeffect
// import Grid from "./grid";
import { useAppSelector, useAppDispatch } from '../../store/hooks'
//import { KonvaEventObject } from "konva/lib/Node";
import { RootState } from "../../store/store";
import {
  setOperation
} from "../../store/interaction"
//import { getToolRenderer } from "./util/shapeCategorySingleton"
//import Konva from "konva";
import { useKeyboard } from "./useKeyboard";
import { useButtonHeld } from "./tools/useButtonHeld";
//import { useSnapMousePosition } from "./tools/useSnapMousePosition";
import { Transform } from "../../geometry/transformation";
import { PointMapper } from "./interface/pointMappings";
import RubberInput from "./interface/rubberInput";
import { sharedPointMapperRef, sharedEditorCanvas, sharedEditedHotspot } from './interface/pointMappings';
import { Line } from "./shapes/line/newline";
import { Polygon } from "./shapes/polygon/newpolygon";
import { Circle } from "./shapes/circle/newcircle";
import { Text } from "./shapes/text/newtext";
//todo: do something with the Image vs Image conflict...
import { Symbol } from "./shapes/symbol/newsymbol";
//import _ from "lodash";
import { getInteractionHandlers } from "./shapes/interactionManager";
import { hitManager } from "./shapes/hitManager"

interface Editor2DProps { }

type Position = {
  x: number;
  y: number;
};

const Editor2d = (props: Editor2DProps) => {
  // Redux Selectors and Dispatch
  const dispatch = useAppDispatch();
  //const editingMode = useAppSelector((state: RootState) => state.interaction.editorState)
  const model = useAppSelector((state: RootState) => state.model.present.model);
  const selectedItemIds = useAppSelector((state: RootState) => state.model.present.selected);
  //const layers = useAppSelector((state: RootState) => state.tool.layerList)
  //const modelSelection = useAppSelector((state: RootState) => state.model.present.selected);
  //const viewport = useAppSelector((state: RootState) => state.interface.viewport);
  const activeTool: ToolType = useAppSelector((state: RootState) => state.tool.currentTool);
  //const snapMousePosition = useSnapMousePosition();
  const divRef = useRef<HTMLDivElement>(null)
//  const stageRef = useRef<Konva.Stage>(null)
  // const [viewportDimensions, setViewportDimensions] = useState<Size2d>({
  //   width: 0,
  //   height: 0
  // })
  useButtonHeld("shift")
  const shiftDown = useAppSelector(state => state.interaction.button.buttonHeld.shift)
  // const worldt = useAppSelector(state => state.interface.worldTransformationMatrix);
  // const zoom = useAppSelector(state => state.interface.zoom);
  // const pos = useAppSelector(state => state.interface.pos);

  const canvasRef = useRef<HTMLCanvasElement>(null);
  //const graphicalInputRef = useRef<HTMLCanvasElement>(null);
  //const [imgLib, setImgLib] = useState<{url: string, img: HTMLImageElement}[]>([]);
  //const canvasContextRef = useRef<CanvasRenderingContext2D>(null);

  const [isDragging, setIsDragging] = useState(false);
  const [dragStart, setDragStart] = useState<Position | null>(null);
  const [viewPort, setViewPort] = useState({top: 0, left: 0, bottom: 0, right: 0});
  //const [offset, setOffset] = useState<Position>({ x: 0, y: 0 });

  const [hotspot, setHotspot] = useState<OffscreenCanvas>(() => new OffscreenCanvas(1, 1));

  const [cursorChanged, setCursorChanged] = useState(false);
  const timerRef = useRef<number | null>(null);
  const MAX_TIME_DIFF = 100; // ms

  const [pointMapper, setPointMapper] = useState<PointMapper>(() => new PointMapper())

  const layerList = useAppSelector((state: RootState) => state.tool.layerList)

  const [hotspots, setHotspots] = useState<Hotspot2d[]>([]);
  const [editedHotspot, setEditedHotspot] = useState<Hotspot2d>();
  const [editedObject, setEditedObject] = useState<GeometricShape>();
  const toolSettings = useAppSelector((state: RootState) => state.tool.toolSettings);
  const operation = useAppSelector((state: RootState) => state.interaction.operation)

  const [interactionHandles, setInteractionHandles] = useState<any>(null);
  const [mode, setMode] = useState<string>("");

  const lineTypes = useAppSelector((state: RootState) => state.tool.lineTypes)

  useEffect(() => {
    const ctx = canvasRef.current?.getContext("2d");
    if (!ctx) {
      console.log("Crytical error, there is no canvas for drawing.");
      return;
    }
    console.log("Canvas for drawing initialized.");
    sharedEditorCanvas.current.setContext(ctx);
  }, [model])

  useEffect(() => {
    sharedPointMapperRef.current = pointMapper;
  }, [pointMapper])

  useEffect(() => {
    sharedEditedHotspot.current = editedHotspot;
  }, [editedHotspot])

  useEffect(() => {
    if (activeTool === "select") {
      if (selectedItemIds.selectedItemIds.length === 1) {
        console.log("initializing edit mode")
        // const shape = editedObject;
        // if (!shape) {
        //   setInteractionHandles(undefined);
        //   return;
        // }
        //const newInteractionHandles = getInteractionHandlers(shape.type, operation);

        const shape = model.shapes[model.shapes.findIndex(o => o.id === selectedItemIds.selectedItemIds[0])];

        const newInteractionHandles = getInteractionHandlers(shape.type, operation);
        console.log("operation: ", operation)
        const newMode = "edit";
        setInteractionHandles(newInteractionHandles);
        if (shape.type === "symbol") {
          setEditedObject(shape);
        }
        else {
          setEditedObject(undefined);
        }
        setMode(newMode);
      }
      else {
        setInteractionHandles(undefined);
      }
    }
    else {

      const shape = toolSettings[activeTool].current;
      if (shape) {
        console.log("creating ", shape.type);
        const newInteractionHandles = getInteractionHandlers(shape.type, "create");
        const newMode = "create";
        setInteractionHandles(newInteractionHandles);
        setEditedObject(shape);
        setMode(newMode);
      }
    }
  }, [activeTool, toolSettings, selectedItemIds, model.shapes, operation])

  useEffect(() => {
    //let isMounted = true;

    // let imageUrls: string[] = [];
    // model.shapes.forEach(shape => {
    //   if (shape.type === "symbol") {
    //     if (shape?.url) {
    //       imageUrls.push(shape.url);
    //     }
    //   }
    // });

    // const loadSymbolsSequentially = async () => {
    //   const result: {url: string, img: HTMLOrSVGImageElement}[] = [];

    //   for (let url of imageUrls) {
    //     try {
    //       const img = (await loadImage(url)) as HTMLOrSVGImageElement;
    //       //result.push({url, img});
    //     } catch (err) {
    //       console.error(`Failed to load image at ${url}`, err);
    //     }
    //   }

    //   if (isMounted) {
    //     setImgLib(result); // Update state only after all images are loaded
    //   }
    // };

    // const loadImagesSequentially = async () => {
    //   const result: {url: string, img: string}[] = [];

    //   for (let url of imageUrls) {
    //     try {
    //       const img = (await loadImage(url)) as HTMLImageElement;
    //       result.push({url, img: img.src});
    //     } catch (err) {
    //       console.error(`Failed to load image at ${url}`, err);
    //     }
    //   }

    //   if (isMounted) {
    //     setImgLib(result); // Update state only after all images are loaded
    //   }
    // };

    //loadImagesSequentially();

    const offscreen = new OffscreenCanvas(8, 8);
    const offscreenContext = offscreen.getContext('2d');
    if (offscreenContext) {
      offscreenContext.beginPath();
      offscreenContext.strokeStyle = "black";
      offscreenContext.arc(4, 4, 3, 0, 2 * Math.PI);
      offscreenContext.fillStyle = "black";
      offscreenContext.fill();
      offscreenContext.stroke();
      setHotspot(offscreen);
    }

    // return () => {
    //   isMounted = false;
    // };
  }, [model, activeTool]);


  // const loadImage = (url: string) => {
  //   return new Promise((resolve, reject) => {
  //     const img = new Image();
  //     img.src = url;
  //     img.onload = () => resolve(img); // return the URL or img element
  //     img.onerror = reject;
  //   });
  // };

  // todo: create proper type for the returned values
  const myRender2 = useCallback((item: GeometricShape) : Hotspot2d[] => {
    const context = canvasRef.current?.getContext("2d");
    if (!context) return [];

    context.imageSmoothingEnabled = false;

    if (item.type === "polyline") {
      return Line.render(item, selectedItemIds.selectedItemIds.includes(item.id), lineTypes);
    }
    if (item.type === "line") {
      return Line.render(item, selectedItemIds.selectedItemIds.includes(item.id), lineTypes);
    }
    if (item.type === "polygon") {
      return Polygon.render(item, selectedItemIds.selectedItemIds.includes(item.id), lineTypes);
    }
    if (item.type === "circle") {
      return Circle.render(item, selectedItemIds.selectedItemIds.includes(item.id), lineTypes);
    }
    if (item.type === "text") {
      return Text.render(item, selectedItemIds.selectedItemIds.includes(item.id), lineTypes);
    }
    if (item.type === "symbol") {
      return Symbol.render(item, selectedItemIds.selectedItemIds.includes(item.id), lineTypes);
    }

    return [];
  }, [selectedItemIds.selectedItemIds, lineTypes]);

  const drawGrid = useCallback(() => {
    sharedPointMapperRef.current = pointMapper;
    const context = canvasRef.current?.getContext("2d");
    if (!context) return;

    if (viewPort.right - viewPort.left > 50000) return;

    let dx = 1000;
    let dy = 1000;
    let x = (Math.round(viewPort.left / dx) * dx);
    let y = (Math.round(viewPort.bottom / dy) * dy);
    while (x > viewPort.left - dx  && x < viewPort.right + dx) {
      const begPoint = sharedPointMapperRef.current.worldToScreen({ x: x, y: y });
      context.beginPath();
      context.strokeStyle = "#cccccc";
      context.lineWidth = 1;
      context.setLineDash([]);
      context.moveTo(begPoint.x, 0);
      context.lineTo(begPoint.x, canvasRef.current?.height ?? 100);
      context.stroke();
      x += dx;
    }
    while (y > viewPort.bottom - dy  && y < viewPort.top + dy) {
      const begPoint = sharedPointMapperRef.current.worldToScreen({ x: x, y: y });
      context.beginPath();
      context.strokeStyle = "#cccccc";
      context.lineWidth = 1;
      context.setLineDash([]);
      context.moveTo(0, begPoint.y);
      context.lineTo(canvasRef.current?.width ?? 100, begPoint.y);
      context.stroke();
      y += dy;
    }

    context.beginPath();
    const begPoint = sharedPointMapperRef.current.worldToScreen({ x: 0, y: 0 });
    context.moveTo(begPoint.x - 5, begPoint.y - 5);
    context.lineTo(begPoint.x + 5, begPoint.y + 5);
    context.moveTo(begPoint.x - 5, begPoint.y + 5);
    context.lineTo(begPoint.x + 5, begPoint.y - 5);
    context.stroke();
  }, [pointMapper, viewPort]);

  useLayoutEffect(() => {
    if (!model || !model.shapes) return;
    if (!canvasRef) return;

    const canvas = canvasRef.current;
    if (!canvas) return;

    const context  = canvas.getContext("2d");
    if (!context) return;

    context.clearRect(0, 0, canvas.width, canvas.height);
    context.save();
    drawGrid();

    //let counter = 0;
    let newhotspots: Hotspot2d[] = [];

    layerList.forEach(layer => {
      model.shapes.forEach(shape => {
        //for (let j = 0; j < 10; ++j) {
        if (shape.layerId === layer.id && layer.visibility) {
          const retVal = myRender2(shape);
          newhotspots = newhotspots.concat(retVal);
        }
          //counter++;
        //}
      });
    })

    //const offset = hotspot.width / 2;
    for (let i = 0; i < newhotspots.length; ++i) {
      sharedEditorCanvas.current.drawImage({ x: newhotspots[i].x, y: newhotspots[i].y }, 0, hotspot, hotspot.width, hotspot.height, {}, { horizontal: "center", vertical: "center" }, true)
    }

    setHotspots(newhotspots);

  }, [model, myRender2, drawGrid, hotspot, pointMapper, layerList]);

  // We cant set the h & w on Stage to 100% it only takes px values so we have to
  // find the parent container's w and h and then manually set those !
  // useEffect(() => {
  //   const handleResize = () => {
  //     if (divRef.current) {
  //       setViewportDimensions(
  //         {
  //           height: divRef.current.offsetHeight,
  //           width: divRef.current.offsetWidth,
  //         }
  //       )
  //       dispatch(
  //         setViewportSize({
  //           height: divRef.current.offsetHeight,
  //           width: divRef.current.offsetWidth,
  //         })
  //       );
  //     }
  //   };

  //   if (divRef.current?.offsetHeight && divRef.current?.offsetWidth) handleResize();

  //   window.addEventListener("resize", handleResize);

  //   // Cleanup: Remove event listener on component unmount
  //   return () => {
  //     window.removeEventListener("resize", handleResize);
  //   };
  // }, [divRef, dispatch])
  useKeyboard();




  // const handleMouseDown = (e: KonvaEventObject<MouseEvent>) => {
  // };

  // THE render in use
  // -------------------
  // const myRender = (item: GeometricShape, id: number) => {

  //   let renderer = getShapeRendererGroup(item.type);
  //   const visible = layers.map((i: Layer) => i.visibility && i.id).includes(item.layerId)
  //   if (renderer && visible) {

  //     return renderer.shapeRender(
  //       item,
  //       (e: KonvaEventObject<MouseEvent>) => { if (activeTool === "select") { onSelectShape(item, e) } },
  //     )
  //   }
  // }



  const handleWheel = (e: WheelEvent<HTMLCanvasElement>) => {
    let newZoom = pointMapper.zoom;
    if (e.deltaY > 0) {
      newZoom /= 1.1;
    }
    if (e.deltaY < 0) {
      newZoom *= 1.1;
    }

    const { clientX, clientY } = e;
    const newPosX = clientX * (1 / pointMapper.zoom - 1 / newZoom) + pointMapper.pos.x;
    const newPosY = clientY * (1 / pointMapper.zoom - 1 / newZoom) + pointMapper.pos.y;

    let t = new Transform(Transform.mat5FlippedIdentity);
    t = t.translate(-newPosX, -newPosY, 0);
    t = t.scale(newZoom, newZoom, newZoom);

    let newPointMapper: PointMapper = new PointMapper();
    newPointMapper.worldToScreenTransform = t;
    newPointMapper.zoom = newZoom;
    newPointMapper.pos = { x: newPosX, y: newPosY };
    setPointMapper(newPointMapper);
    let newViewPort = { left: newPosX, top: -newPosY, right: newPosX + (canvasRef.current?.width ?? 100) / newZoom, bottom: -newPosY - (canvasRef.current?.height ?? 100) / newZoom };
    setViewPort(newViewPort);
  };

  const getMousePos = (event: MouseEvent): Position => {
    const rect = canvasRef.current!.getBoundingClientRect();
    // console.log({
    //   x: event.clientX - rect.left,
    //   y: event.clientY - rect.top
    // });
    return {
      x: event.clientX - rect.left,
      y: event.clientY - rect.top
    };
  };

  const handleMouseDown = (event: MouseEvent<HTMLCanvasElement>) => {
    setIsDragging(true);
    setDragStart(getMousePos(event));

    // Start a timeout to change cursor if held too long
    timerRef.current = window.setTimeout(() => {
      if (canvasRef.current) {
        canvasRef.current.style.cursor = 'grabbing';
        setCursorChanged(true);
      }
    }, MAX_TIME_DIFF);

  };

  const handleMouseMove = (e: MouseEvent<HTMLCanvasElement>) => {
    const wp = pointMapper.screenToWorld({ x: e.clientX, y: e.clientY });
    dispatch(setMouseUnmodifiedPosition({ x: wp.x, y: wp.y }));

    if (!isDragging || !dragStart) return;

    //const currentPos = getMousePos(e);
    const currentPos = {x: e.clientX, y: e.clientY};
    const dx = (currentPos.x - dragStart.x) ;
    const dy = (currentPos.y - dragStart.y) ;

    let newt = new Transform(pointMapper.worldToScreenTransform.getMatrix());
    newt.translate(dx, dy, 0);
    // setWorldt(newt.getMatrix());

    // setPos((prev) => ({
    //   x: prev.x - dx / zoom,
    //   y: prev.y - dy / zoom
    // }));
    const newPointMapper: PointMapper = new PointMapper();
    newPointMapper.worldToScreenTransform = newt;
    newPointMapper.zoom = pointMapper.zoom;
    newPointMapper.pos = {
      x: pointMapper.pos.x - dx / pointMapper.zoom,
      y: pointMapper.pos.y - dy / pointMapper.zoom
    };
    setPointMapper(newPointMapper);

    // let offset = newt.getTranslation();
    // setPos(newt.getTranslation());
    const newPos = { x: pointMapper.pos.x - dx / pointMapper.zoom, y: pointMapper.pos.y - dy / pointMapper.zoom }
    let newViewPort = { left: newPos.x, top: -newPos.y, right: newPos.x + (canvasRef.current?.width ?? 100) / pointMapper.zoom, bottom: -newPos.y - (canvasRef.current?.height ?? 100) / pointMapper.zoom };
    setViewPort(newViewPort);
    setDragStart(currentPos);
  };


  const handleMouseUp = (event: MouseEvent<HTMLCanvasElement>) => {
    setIsDragging(false);
    setDragStart(null);
    console.log("dropped");

          // Reset state
    if (timerRef.current) clearTimeout(timerRef.current);
    if (cursorChanged) {
      if (canvasRef.current) {
        canvasRef.current.style.cursor = 'default';
        setCursorChanged(false);
      }
    }

    // if (editedObject) {
    //   return;
    // }
    if (activeTool !== "select") return;

    let anyHit: boolean = false;
    const p = sharedPointMapperRef.current.screenToWorld({ x: event.clientX, y: event.clientY });

    // checking hotspot hit
    const oldEditedHotspot = editedHotspot;
    let newEditedHotspot;
    for (let i = 0; i < hotspots.length; ++i) {
      //todo: use geometry distancePow2 and proper Global constant * constant
      if (Math.pow(hotspots[i].x - p.x, 2) + Math.pow(hotspots[i].y - p.y, 2) < 25 ) {
        newEditedHotspot = hotspots[i];
        console.log("hotspot hit");
        dispatch(setOperation("edit"))
        break;
      }
    };

    if (newEditedHotspot) {
      console.log("setting hotspot reference")
      setEditedHotspot(newEditedHotspot);

      // const objArr = model.shapes.filter(o => o.id === newEditedHotspot.shapeId);
      // if (objArr.length !== 0) {
      //   const obj = objArr[0];
      //   setEditedObject(obj);
      // }

      sharedEditedHotspot.current = newEditedHotspot;
      return;
    }

    // if hotspot is under editing, or was just released, the selection state should not change
    if (oldEditedHotspot) {
      console.log("just finished editing")
      setEditedHotspot(undefined);
      dispatch(setOperation(""))
      return;
    }

    if (selectedItemIds.selectedItemIds.length > 0) {
      // for (let i = 0; i < selectedItemIds.selectedItemIds.length; ++i) {
      //   const objArr = model.shapes.filter(o => o.id === selectedItemIds.selectedItemIds[i]);
      //   if (objArr.length === 0) {
      //     continue;
      //   }

      //   const obj = objArr[0];
      //   const isHit = hitManager.get(obj.type as string);
      //   if (isHit && isHit(model.shapes[i], p)) {
      //     console.log("edited is set")
      //     setEditedObject(obj);
      //     return;
      //   }
      // }
    }

    // checking selection
    for (let i = 0; i < model.shapes.length; ++i) {
      try {
        const isHit = hitManager.get(model.shapes[i].type as string);
        if (isHit && isHit(model.shapes[i], p)) {
          if (!shiftDown) {
            dispatch(exitSelection());
          }
          dispatch(addItemToSelection(model.shapes[i].id));
          anyHit = true;
        }
      }
      catch {}

    }
    if (!anyHit) {
      dispatch(exitSelection());
    }


  };


  // const drawRubberline = () => {
  //   if (activeTool === "select") return;

  //   const toolRenderer = getToolRenderer(activeTool);
  //   if (toolRenderer) {
  //     return toolRenderer.toolRender();
  //   } else console.warn("not found tool renderer for ", activeTool);
  // }



  // if (editedObject && interactionHandles) {
  //   console.log("---- has input: ", mode);
  // }

  return (
    <div ref={divRef} style={{ width: '100%', height: '100%', zIndex: "50", overflow: "hidden" }}>
      <canvas
        width={window.innerWidth}
        height={window.innerHeight}
        ref={canvasRef}
        onWheel={!((editedObject || editedHotspot) && interactionHandles) ? handleWheel : () => {}}
        onMouseMove={!((editedObject || editedHotspot) && interactionHandles) ? handleMouseMove : () => {}}
        onMouseDown={!((editedObject || editedHotspot) && interactionHandles) ? handleMouseDown : () => {}}
        onMouseUp={!((editedObject || editedHotspot) && interactionHandles) ? handleMouseUp : () => {}}
      >
      </canvas>
      {(editedObject || editedHotspot) && interactionHandles &&
      <>
        <RubberInput
          mode={mode}
          shape={editedObject ?? model.shapes[model.shapes.findIndex(o => o.id === editedHotspot?.shapeId)]}
          rubberInputInit={interactionHandles.rubberInputInit}
          rubberInputRenderer={interactionHandles.rubberInputRenderer}
          rubberInputUpdater={interactionHandles.rubberInputUpdater}
          callback={interactionHandles.callback}
          onWheel={handleWheel}
          onMouseMove={handleMouseMove}
          onMouseDown={handleMouseDown}
          onMouseUp={handleMouseUp}
        >
        </RubberInput>
      </>
      }

    </div>
  );
};

export default Editor2d;
